module.exports = __webpack_public_path__ + "img/3-2.ca872e60.svg";